import React from 'react';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import {
	Nav4MenuLinkItem,
	type Nav4MenuLinkItemProps,
} from '../../common/ui/nav4-menu-link-item/index.tsx';

type Props = Omit<Nav4MenuLinkItemProps, 'elemBefore'>;

export function ViewAllEntityMenuItem(props: Props): React.JSX.Element {
	return (
		<Nav4MenuLinkItem {...props} elemBefore={<AlignTextLeftIcon label="" color="currentColor" />} />
	);
}
